// extracted by mini-css-extract-plugin
export default {"wrapper":"List_wrapper__EAlSR","item":"List_item__fslO7","link":"List_link__EfiHP","itemText":"List_itemText__8sEua","nav":"List_nav__nJXjX"};